module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/0199959ab3dc6e166d30f1d36bc77e0b.svg";


//////////////////
// WEBPACK FOOTER
// ./components/participation-table/certificate-display/assets/download-icon.svg
// module id = Gczr
// module chunks = 1